import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import image1 from "assets/img/14122018.png";
import image101 from "assets/img/14122018-1.png";
import image102 from "assets/img/14122018-2.png";
// import imageIso from "assets/img/27000family.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center"  style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={10}>
              <Card>
                <CardBody>
                  <span style={{ marginBottom: 0 }}>14 Desember 2018, 08.00 PM</span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>Resiko dan Peluang pada ISO 9001:2015</b></h2>
                  <span style={{ fontSize: 18 }}>
                    <center>
                      <img src={image1} alt="Images" style={{ width: 500, height: 350, marginRight: 25 }} />
                    </center> <br />
                    <p style={{ fontSize: 18 }}>
                    Banyak orang yang bertanya kenapa Standar ISO 9001 itu direvisi dan apa saja hal-hal baru yang muncul di revisi terbaru. <br/>
                    Sekedar informasi bahwa ISO 9001 telah direvisi sebanyak 4 kali (Revisi terakhir 2015) mulai dari ISO 9001 pertama kali terbit di tahun 1987.
                    </p>
                    <center>
                      <img src={image101} alt="Images" style={{ width: 500, height: 350, marginRight: 25 }} />
                    </center> <br />
                    <p style={{ fontSize: 18 }}>
                    Pada setiap tahun revisi titik pasti terdapat perubahan pada titik fokus implementasinya dan hal ini disebabkan karena beberapa faktor, antara lain:
                    </p>
                    <ol>
                      <li>Trend terbaru</li>
                      <li>Kompatibilitas dengan Sistem Manajemen yang lain</li>
                      <li>Up-to-date dengan dinamika bisnis dunia</li>
                    </ol>
                    <p style={{ fontSize: 18 }}>
                    Dari beberapa faktor diatas, kalau akan kita tuliskan dalam artikel ini mungkin akan terlalu lebar, panjang dan luas sehingga akan tidak tepat pada sasaran. Oleh karena itu, materi ini akan dikerucutkan pada faktor Trend terkini.
                    Trend yang sedang berkembang saat ini adalah permasalahan safety dan hampir di seluruh dunia sangat berfokus pada safety, baik itu pada aktifitas kerja, makanan, informasi dsb.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Pengendalian safety dimulai dengan identifikasi bahaya yang mencakup resiko-resiko yang mungkin akan terjadi sehinggan berdampak buruk. Hal ini menjadi pertimbangan dalam implementasi sistem manajemen mutu, secara logika mungkin sebaiknya kita mampu menghindari trouble sebelum terkena trouble atau sebisa mungkin kita menghindari kerugian sebelum mengalami kerugian. Pertimbangan semacam itu yang kemudian memunculkan suatu gagasan untuk mengatasi resiko dan memperoleh peluang untuk efektifitas sistem manajemen mutu.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Coba kita lihat di ISO 9001:2008, persyaratan yang ada didalamnya terdapat tindakan korektif dan preventif sehingga organisasi akan menunggu terjadinya problem kemudian menyelesaikannya dan menetapkan tindakan pencegahan. Biaya untuk menetapkan tindakan pencegahan juga tidak sedikit apabila ditambah lagi setelah adanya tindakan korektif yang belum lagi problem itu akan melebar dan hal ini sangat tidak relevan terhadap dinamika bisnis. Dengan adanya persyaratan terkait tindakan untuk mengatasi resiko dan peluang, organisasi diharapkan mampu untuk meminimalisir terjadinya ketidaksesuaian baik proses atau produk/jasa yang mengakibatkan kerugian.
                    </p>
                    
                    <p style={{ fontSize: 18 }}>
                    <b>
                      Apa itu Resiko?
                    </b>
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Resiko adalah bahaya, akibat atau konsekuensi yang dapat terjadi akibat sebuah proses yang sedang berlangsung atau kejadian yang akan datang.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    <b>
                      Apa itu Manajemen Resiko?
                    </b>
                    </p>
                    Manajemen Resiko adalah Suatu pendekatan terstruktur/metodologi dalam mengelola ketidakpastian yang berkaitan dengan ancaman; suatu rangkaian aktivitas manusia termasuk: Penilaian risiko, pengembangan strategi untuk mengelolanya dan mitigasi risiko dengan menggunakan pemberdayaan/pengelolaan sumberdaya. (Wikipedia).
                    <br/>
                    Standar ISO 9001 versi 2015 telah mensyaratkan setiap organisasi yang mengimplementasikannya untuk menetapkan resiko dan peluang terhadap hal - hal yang berpengaruh pada proses bisnisnya
                    <p style={{ fontSize: 18 }}>
                    <b>
                      Proses Menetapkan Tindakan Untuk Mengatasi Resiko dan Peluang
                    </b>
                    </p>
                    <p style={{ fontSize: 18 }}>
                    ISO 9001:2015 secara eksplisit memang tindak menjelaskan secara terperinci mengenai metode ataupun tahap-tahap dalam menetapkan tindakan untuk mengatasi Resiko dan Peluang. Perlu kita ketahui bahwa metode untuk mengatasi resiko dan peluang atau dalam artian Manajemen Resiko sangat banyak dan beragam.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Para ahli telah menetapkan beberapa metode yang mampu menidentifikasi resiko hingga menetapkan pengendalian atau mitigasinya secara kuantitatif dan terukur.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Berikut contoh beberapa metode :
                    </p>
                    <ul>
                      <li>Metode dasar manajemen risiko (flowcharts, check sheets, dll.)</li>
                      <li>Failure Mode Effects Analysis (FMEA)</li>
                      <li>Failure Mode, Effects and Criticality Analysis (FMECA)</li>
                      <li>Fault Tree Analysis (FTA)</li>
                      <li>Hazard Analysis and Critical Control Points (HACCP)</li>
                      <li>Hazard Operability Analysis (HAZOP)</li>
                      <li>Preliminary Hazard Analysis (PHA)</li>
                      <li>Penyaringan dan pemberian skala (pemeringkatan) risiko</li>
                      <li>Perangkat statistik pendukung</li>
                    </ul>
                    <p style={{ fontSize: 18 }}>
                    dari contoh metode-metode yang telah dikembangkan para ahli seperti diatas, secara umum rule model yang diterapkan untuk mengidentifikasi resiko adalah sebagai berikut:
                    </p>
                    <br />
                    <center>
                      <img src={image102} alt="Images" style={{ width: 700, height: 450, marginRight: 25 }} />
                      <p style={{ fontSize: 18 }}><b>Gambar 2. Model Identifikasi Resiko (ISO 31000:2009)</b></p>
                    </center> <br />
                    <p style={{ fontSize: 18 }}>
                    Langkah - langkah resiko:
                    </p>
                    <p style={{ fontSize: 18 }}>
                    <b>1. Menetapkan Konteks Organisasi</b>                    
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Dengan menetapkan konteksnya, organisasi mampu menidentifikasi tujuannya dengan mendefinisikan issue inetrnal dan issue eksternal di organisasi. Saat menetapkan konteks untuk proses manajemen risiko, organisasi perlu mempertimbangkan secara lebih rinci dan terutama bagaimana kaitannya dengan lingkup risiko pada proses manajemen.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    <b>2. Penilaian Resiko</b>
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Resiko dapat dikendalikan secara efektif apabila terdapat Penilaian Resiko. Mengacu pada gambar 2 penilaian risiko terdiri dari:
                    <ul>
                      <li>Identifikasi Resiko </li>
                      <li>Analisis Resiko </li>
                      <li>Evaluasi risiko </li>
                    </ul>
                    </p>
                    <p style={{ fontSize: 18 }}>
                    <b>3. Pengendalian Resiko</b>
                    </p>
                    <p style={{ fontSize: 18 }}>
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Setelah dilakukan Penilaian Resiko, kita akan mengetahui seberapa besar peluang terjadinya, seberapa besar dampaknya dan pada ujungnya adalah bagaimana pengendaliannya. Pengendalian risiko meliputi pengambilan suatu keputusan dimana kita harus menetukan untuk mengurangi dan/ atau menerima risiko. Target dari pengendalian risiko adalah untuk meminimalisir risiko tersebut sampai batas yang dapat diterima. Dalam pengambilan keputusan, terdapat hal - hal yang dapat mempengaruhi keputusan yang diambil.Sangat dimungkinkan menggunakan proses yang berbeda, termasuk analisis keuntungan-biaya, untuk memahami tingkat yang optimal terhadap pengendalian risiko.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    <b>4. Evaluasi Resiko</b>
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Evaluasi resiko diperlukan untuk mengetahui relevansi resiko-resiko yang telah ditetapkan. Pada saat proses Manajemen Risiko telah dimulai, proses tersebut hendaklah dilanjutkan untuk digunakan dalam kejadian yang mungkin memberi dampak pada keputusan Manajemen Risiko Mutu awal, baik kejadian tersebut direncanakan (misal, hasil pengkajian produk, inspeksi, audit, pengendalian perubahan) maupun yang tidak direncanakan (misal, akar penyebab masalah dari investigasi penyimpangan, penarikan kembali produk jadi).
                    <br/>                    
                    Frekuensi evaluasi hendaklah didasarkan pada tingkat risiko. Evaluasi risiko dapat termasuk mempertimbangkan kembali keputusan penerimaan risiko.
                    </p>
                  </span>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/News/Sections/ProductSection.3.jsx